import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { SmartAlertsApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/smart-alerts/smart-alerts-api';
import { PreferenceItemResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/smart-alerts/preferences.response';
import { UpdatePreferencesRequest } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/requests/smart-alerts/update-preferences.request';
import { AlertSeverity } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@enums/alert-severity.enum';

@Component({
  selector: 'vw-notification-preferences-toast',
  imports: [SharedModule, FormsModule, TranslatePipe],
  templateUrl: './notification-preferences-toast.component.html',
  styleUrl: './notification-preferences-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [{ provide: SmartAlertsApi, useClass: SmartAlertsApi }],
})
export class NotificationPreferencesToastComponent
  extends BaseToastComponent
  implements OnChanges
{
  preferences: PreferenceItemResponse[] = [];
  loading = false;
  saving = false;

  /**
   * Categorie dont l'aide est dépliée, ou `null`.
   *
   * Une seule à la fois : « Croissance » ou « Entretien » ne disent rien tant
   * qu'on n'a pas vu à quoi ressemble l'alerte. Tout afficher d'office
   * noierait les réglages, qui sont ce que l'utilisateur vient chercher.
   */
  expanded: string | null = null;

  toggleInfo(category: string): void {
    this.expanded = this.expanded === category ? null : category;
  }

  readonly severityOptions = [
    {
      value: AlertSeverity.INFO,
      label: 'profile.notification-preferences.severities.INFO',
    },
    {
      value: AlertSeverity.WARNING,
      label: 'profile.notification-preferences.severities.WARNING',
    },
    {
      value: AlertSeverity.CRITICAL,
      label: 'profile.notification-preferences.severities.CRITICAL',
    },
  ];

  constructor(private smartAlertsApi: SmartAlertsApi) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    // (Re)load the preferences each time the toast is opened.
    if (changes['isOpen'] && this.isOpen) {
      this.expanded = null;
      this.load();
    }
  }

  async load() {
    this.loading = true;
    try {
      const res = await this.smartAlertsApi.getPreferences();
      this.preferences = res?.preferences ?? [];
    } finally {
      this.loading = false;
    }
  }

  async save() {
    this.saving = true;
    try {
      const request = new UpdatePreferencesRequest();
      request.preferences = this.preferences.map((p) => ({
        category: p.category,
        isEnabled: p.isEnabled,
        pushEnabled: p.pushEnabled,
        minPushSeverity: p.minPushSeverity,
      }));
      await this.smartAlertsApi.updatePreferences(request);
      this.onClose(true);
    } finally {
      this.saving = false;
    }
  }
}
